export default {"src":"/_next/static/media/pipesIconWhite.6e92a632.svg","height":70,"width":71};